'use client';

// types
import type { ContentElementPayload } from 'components/ContentElements/content-elements-payload';

// components
import { ContentArea } from 'components/ContentArea/ContentArea';

// utils
import { isEmpty } from 'utils/is-empty';
import { useContent } from 'components/Page/page-hooks';

type LandingPageProps = {
  contentAreas: {
    landingpage_content: ContentElementPayload[];
  };
};

export function Landingpage() {
  const page = useContent<LandingPageProps, {}>();

  if (isEmpty(page)) {
    return null;
  }

  const content = page?.contentAreas?.landingpage_content || [];
  return (
    <ContentArea content={content} contentType="landingpage_content" />
  );
}
